export default "__VITE_ASSET__QYxDdTx5__"